/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
import RoundLoader from 'components/shared/loader/round/round';
import SillyLoader from 'components/shared/loader/silly/silly';
import EllipsisLoader from 'components/shared/loader/ellipsis/ellipsis';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/loader/loader_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});


/* ========== ~~~~~~~~~~ LOADER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Loader = (props) => {
	const displayLoaderType = () => {
		switch (props.type) {
			case 'silly':
				return <SillyLoader /> ;
			case 'ellipsis':
				return <EllipsisLoader />;
			case 'round':
			default:
				return <RoundLoader />;
		}
	}
	return (
        <div className={`${sheet.classes.loader} loader`}>
        	<div className={'loaderContainer'}>
                {displayLoaderType()}
            </div>
        </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Loader;
